/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
import axios from '@/config/backend'

export default class BANOC {

    constructor() {
        this.errors = []
    }

    coordinates({ latitude, longitude, level }) {
        return axios.get('/api/banoc/geocode/coordinates', {
            params: { latitude, longitude, level }
        })
    }

    reverseSearch({ lat, lon, level }) {
        return this.coordinates({ latitude: lat, longitude: lon, level })
    }

    reverseHandle(data) {
        const cells = (data && data.data) || []
        if (!cells.length) {
            this.errors.push('error.search.noData')
            return ''
        }
        const cell = cells[0]
        if (cell.jurisd_local_id) {
            this.jurisdLocalId = cell.jurisd_local_id
        }
        const parts = [
            cell.code_b32nvu,
            cell.city && cell.city.city,
            cell.city && cell.city.iso_label
        ].filter(Boolean)
        return parts.join(', ')
    }

    search(locationName) {
        return axios.get('/api/banoc/geocode/search', {
            params: {
                format: 'banoc,city',
                q: locationName,
                jurisd_local_id: this.jurisdLocalId || undefined
            }
        })
    }

    handle(data) {
        const cities = (data && data.cities) || []
        const banocCodes = (data && data.banoc_codes) || []
        if (!cities.length && !banocCodes.length) {
            this.errors.push('error.search.noData')
            return []
        }
        const cityResults = cities.map((c) => ({
            address: [c.city, c.iso_label].filter(Boolean).join(', '),
            lat: c.lat,
            lon: c.lon
        }))
        const banocResults = banocCodes.map((cell) => {
            const parts = [
                cell.code_b32nvu,
                cell.city && cell.city.city,
                cell.city && cell.city.iso_label
            ].filter(Boolean)
            const coords = cell.centroide && cell.centroide.coordinates
            return {
                address: parts.join(', '),
                lat: coords ? coords.lat : null,
                lon: coords ? coords.lon : null
            }
        })
        return [...cityResults, ...banocResults].filter((r) => r.lat && r.lon)
    }

}
